import { atom } from 'recoil';

const addressesAtom = atom({
    key: 'addresses',
    default: {
        contract: '',
        distribution: '',
        customDistribution: '',
        current: '',
    },
});

export default addressesAtom;
